// config/restaurant.js

const restaurantConfig = {
  // Basic Info
  name: process.env.REACT_APP_RESTAURANT_NAME,
  address: process.env.REACT_APP_RESTAURANT_ADDRESS,
  phone: process.env.REACT_APP_RESTAURANT_PHONE,
  email: process.env.REACT_APP_RESTAURANT_EMAIL,
  website: process.env.REACT_APP_RESTAURANT_WEBSITE,
  slogan: process.env.REACT_APP_RESTAURANT_SLOGAN,
  currency: process.env.REACT_APP_RESTAURANT_CURRENCY,
  
  // Location
  country: process.env.REACT_APP_RESTAURANT_COUNTRY,
  city: process.env.REACT_APP_RESTAURANT_CITY,
  state: process.env.REACT_APP_RESTAURANT_STATE,
  
  // Business Info
  operatingHours: process.env.REACT_APP_RESTAURANT_OPERATING_HOURS,
  
  // Support
  supportEmail: process.env.REACT_APP_RESTAURANT_SUPPORT_EMAIL,
  supportPhone: process.env.REACT_APP_RESTAURANT_SUPPORT_PHONE,

  // Government Charges
  govtVATRate: parseFloat(process.env.REACT_APP_GOVERNMENT_VAT_RATE),

  // Service Charges
  serviceChargeRate: parseFloat(process.env.REACT_APP_SERVICE_CHARGE_RATE),
};

export default restaurantConfig;